export default __webpack_public_path__ + "static/media/world.0ed22f2d.jpeg";